// extracted by mini-css-extract-plugin
module.exports = {"link":"ExternalAccreditation_link__TalrG","logo":"ExternalAccreditation_logo__1xbk_"};